import axios from 'axios';

export const RequestsApi = {
  getRequests: filter => axios.get(
    `/api/public/info/paging/request_form/requester?filter=${JSON.stringify(filter)}`
  ),
  downloadReportForm: (requestFormId, reportId) => axios.get(
    `/api/public/info/request_form_preview/${requestFormId}/${reportId}?force=true`,
    { responseType: 'blob' }
  )
};